/* ==========================================================================
   Oji Matcha — PDP Scroll Animations
   IntersectionObserver-based reveal system matching homepage aesthetic
   Supports .oji-animate (legacy) and .oji-in-view-target (new sections)

   OJI FIX: single-load hardening —
   - This file is included by several PDP sections (section order is
     merchant-editable, so every section keeps its own <script defer> tag);
     the window.__ojiAnimInit guard makes duplicate executions a no-op.
   - Re-scans on shopify:section:load so sections added/re-rendered in the
     theme editor still get their reveal animations.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__ojiAnimInit) return;
  window.__ojiAnimInit = true;

  /* OJI FIX (T8): reveal-fallback handshake. Every oji-pdp-*.css file that
     primes `.oji-animate` / `.oji-in-view-target` elements with `opacity: 0`
     also carries a `html:not(.oji-anim-ready)` guard that forces them visible.
     Adding the class here — before any element is observed — arms the hides
     only once this file has actually executed. If the request for this file
     is ever blocked (ad-blocker, offline, CDN error), the class never appears
     and all content stays visible by default. On normal loads this deferred
     script runs before first paint, so behavior is unchanged. */
  document.documentElement.classList.add('oji-anim-ready');

  const SELECTOR = '.oji-animate, .oji-in-view-target';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reduced motion: reveal everything immediately, no observers.
  if (reducedMotion) {
    const revealAll = function (root) {
      (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
        el.classList.add('oji-in-view');
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        revealAll(document);
      });
    } else {
      revealAll(document);
    }

    document.addEventListener('shopify:section:load', function (evt) {
      revealAll(evt.target || document);
    });
    return;
  }

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('oji-in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  const scan = function (root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (!el.classList.contains('oji-in-view')) {
        observer.observe(el);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  // Theme editor / late-added sections: re-scan the (re)loaded section only.
  document.addEventListener('shopify:section:load', function (evt) {
    scan(evt.target || document);
  });
})();
